
export default {
  name: 'TradingHours',
  data() {
    return {
      timings: this.$t('timings'),
    }
  },
}
